import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DashboardLayout from "../../layouts/DashboardLayout";

import { getDietPlan, updateDietPlan } from "../../services/dietPlanService";

import "./DietPlans.css";

export default function EditDietPlan() {
  const navigate = useNavigate();

  const { id } = useParams();

  const [formData, setFormData] = useState({
    planName: "",
    goal: "",

    breakfast: "",
    morningSnack: "",
    lunch: "",
    eveningSnack: "",
    dinner: "",

    calories: "",
    protein: "",
    carbs: "",
    fat: "",
    water: "",

    notes: "",
  });

  useEffect(() => {
    loadDietPlan();
  }, []);

  const loadDietPlan = async () => {
    try {
      const data = await getDietPlan(id);

      if (data) {
        setFormData(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async () => {
    try {
      await updateDietPlan(id, formData);

      alert("Diet Plan Updated Successfully");

      navigate("/diet-plans");
    } catch (error) {
      console.error(error);

      alert("Failed to Update Diet Plan");
    }
  };

  return (
    <DashboardLayout>
      <div className="diet-container">
        <div className="diet-header">
          <div>
            <h1>Edit Diet Plan</h1>

            <p>Update your diet plan.</p>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-grid">
            <div className="form-group">
              <label>Plan Name</label>

              <input
                type="text"
                name="planName"
                value={formData.planName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Goal</label>

              <select name="goal" value={formData.goal} onChange={handleChange}>
                <option value="">Select Goal</option>

                <option>Weight Loss</option>

                <option>Weight Gain</option>

                <option>Muscle Gain</option>

                <option>Fat Loss</option>

                <option>General Fitness</option>
              </select>
            </div>

            <div className="form-group">
              <label>Breakfast</label>

              <input
                type="text"
                name="breakfast"
                value={formData.breakfast}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Morning Snack</label>

              <input
                type="text"
                name="morningSnack"
                value={formData.morningSnack}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Lunch</label>

              <input
                type="text"
                name="lunch"
                value={formData.lunch}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Evening Snack</label>

              <input
                type="text"
                name="eveningSnack"
                value={formData.eveningSnack}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Dinner</label>

              <input
                type="text"
                name="dinner"
                value={formData.dinner}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Calories</label>

              <input
                type="number"
                name="calories"
                value={formData.calories}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Protein (g)</label>

              <input
                type="number"
                name="protein"
                value={formData.protein}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Carbohydrates (g)</label>

              <input
                type="number"
                name="carbs"
                value={formData.carbs}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Fat (g)</label>

              <input
                type="number"
                name="fat"
                value={formData.fat}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Water Intake (Litres)</label>

              <input
                type="number"
                name="water"
                value={formData.water}
                onChange={handleChange}
              />
            </div>

            <div className="form-group full-width">
              <label>Notes</label>

              <textarea
                rows="5"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
              />
            </div>
          </div>

          <button className="add-plan-btn" onClick={handleUpdate}>
            Update Diet Plan
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
